import { jsxs as c, jsx as m } from "react/jsx-runtime";
import { fordProIcons as v } from "@fcamna/shared-icons";
import { c as r } from "./index-65016bfa.mjs";
import l from "react";
import { styled as n, css as i } from "styled-components";
import "@fcamna/shared-component-foundations";
import { u as y } from "./useQuantum-50e8fd44.mjs";
import "./isClient-ec947a14.mjs";
import "./useSlots-a1aa6a84.mjs";
import { Grid as u } from "./grid.js";
import { h as C } from "./hTag-27bb1617.mjs";
import { Tooltip as d } from "./tooltip.js";
import "./_commonjsHelpers-92157f1b.mjs";
import "./uniqueId-321287e8.mjs";
import "react-dom";
import "./usePopoverIndex-b3a93ecd.mjs";
import "./useWindowSize-88e90e04.mjs";
import "./getElementPosition-a8642645.mjs";
const { InformationFilled: w } = v, g = n.div`
  &.section-mainWrapper {
    ${({
  theme: {
    componentStyles: o,
    components: { readOnlySection: t }
  }
}) => i(t.MainWrapper, o)};
  }
`, x = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.HeaderSection)};
`, L = n(C)`
  && {
    ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.SectionTitle)};
  }
`, D = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.Subtitle)};
`, G = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.Description)};
`, M = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.SecondaryLabel)};
`, N = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.ContentWrapper)};
`, j = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.RowItemWrapper)};
`, H = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.RowItemTitle)};
`, O = n.div`
  ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.RowTitleWrapper)};
`, P = n(u)`
  &.grid--Content {
    ${({
  theme: {
    components: { readOnlySection: o }
  }
}) => i(o.GridContent)};
  }
`, $ = ({ label: o, infoText: t, value: p }) => /* @__PURE__ */ c(j, { "data-testid": "Items", children: [
  /* @__PURE__ */ c(O, { children: [
    /* @__PURE__ */ m(H, { children: o }),
    t && /* @__PURE__ */ m(
      d,
      {
        placement: "auto",
        title: t,
        children: /* @__PURE__ */ m(
          w,
          {
            tabIndex: 0,
            size: "s"
          }
        )
      }
    )
  ] }),
  /* @__PURE__ */ m(N, { children: p })
] }), _ = ({
  className: o,
  header: t,
  children: p,
  columnOptions: a = { xl: 2, l: 4, m: 6, s: 12 },
  variant: e = "Condensed"
}) => {
  const f = y({ label: "Read Only Section" }), { xl: W, l: I, m: R, s: b } = a, S = () => /* @__PURE__ */ m(
    P,
    {
      className: r([[`grid--Content--${e}`]]),
      gutterWidth: 24,
      children: l.Children.map(p, (s, T) => s && l.isValidElement(s) && s.type === $ ? /* @__PURE__ */ m(
        u.Item,
        {
          xl: W,
          l: I,
          m: R,
          s: b,
          children: s
        },
        T
      ) : null)
    }
  );
  return /* @__PURE__ */ c(
    g,
    {
      className: r([[`${o}`, "section-mainWrapper", `section-mainWrapper--${e}`]]),
      ...f,
      children: [
        /* @__PURE__ */ c(x, { "data-testid": "headersection", children: [
          (t == null ? void 0 : t.title) && /* @__PURE__ */ m(L, { as: t == null ? void 0 : t.headingLevel, children: t == null ? void 0 : t.title }),
          (t == null ? void 0 : t.subTitle) && /* @__PURE__ */ m(D, { children: t == null ? void 0 : t.subTitle }),
          (t == null ? void 0 : t.description) && /* @__PURE__ */ m(G, { children: t == null ? void 0 : t.description }),
          (t == null ? void 0 : t.secondaryLabel) && /* @__PURE__ */ m(M, { children: t == null ? void 0 : t.secondaryLabel })
        ] }),
        S()
      ]
    }
  );
};
_.Item = $;
export {
  _ as ReadOnlySection
};
